import React from 'react'

import ModalHeader from '@/modules/Cart/shared/ModalHeader/ModalHeader'

export const ConfirmationTitle = () => {
    const metadata = {
        title: 'Commande validée',
        description: 'Votre commande a été validée avec succès.',
    }
    return <ModalHeader {...metadata} />
}
export const Confirmation = () => {
    return <div>Confirmation</div>
}
